@if (configuration.display) {
<div class="ras-brand-container">
    <h2 class="ras-brand-title" [style]="configuration.titleStyles">
        {{ configuration.title }}
    </h2>
    <div class="ras-brand-img-container" [class.ie]="isIE">
        @for (brand of configuration.content; track brand) {
        <div class="ras-brand-item">
            <ng-container
                *ngTemplateOutlet="
                    !brand.link ? imgContainer : linkContainer;
                    context: { $implicit: brand }
                "
            ></ng-container>
        </div>
        }
    </div>
</div>
}

<ng-template #linkContainer let-brand>
    @if (brand.link.type === 'a') {
    <a [href]="brand.link.url">
        <ng-container
            *ngTemplateOutlet="imgContainer; context: { $implicit: brand }"
        ></ng-container>
    </a>
    } @if (brand.link.type === 'a-ng') {
    <a
        [routerLink]="brand.link.url"
        [queryParams]="getParams(brand.link.params)"
    >
        <ng-container
            *ngTemplateOutlet="imgContainer; context: { $implicit: brand }"
        ></ng-container>
    </a>
    }
</ng-template>

<ng-template #imgContainer let-brand>
    <div class="ras-brand-card">
        <div class="img-container">
            <img
                [src]="brand.image_url"
                [attr.alt]="'Shop By Brand - ' + brand.title"
                loading="lazy"
            />
        </div>
        <p>{{ brand.title }}</p>
    </div>
</ng-template>
